export const localDe = {

}
